<template>
    <div>
      <Header4></Header4>
      <div class="help">
        <img class="banner" v-if="material.pc_index_top_banner" :src="img_url + material.pc_index_top_banner.img">
        <div class="container">
            <h3 class="mt-2 help_title">联系我们 - {{ getClient.channel_name }} </h3>
            <div class="system-title">在线客服</div>
            <div class="card_body">
                <div class="card_box">
                    <div class="left_box">
                        <span class="card_text">微信扫码添加平台客服</span>
                        <span class="card_text mt-2">早班接待时间：09:00-18:30</span>
                    </div>
                    <img class="ewm" src="/image/kf/mkf.png">
                </div>
                <div class="card_box">
                    <div class="left_box">
                        <span class="card_text">微信扫码添加平台客服</span>
                        <span class="card_text mt-2">晚班接待时间：14:00-00:30</span>
                    </div>
                    <img class="ewm" src="/image/kf/nkf.png">
                </div>
            </div>
        </div>
      </div>
      <Footer2></Footer2>
    </div>
  </template>
  
  <script>
      import Header4 from '../components/Header4.vue'
      import Footer2 from '../components/Footer2.vue'
      import { mapState } from 'vuex';
      export default {
          components: { Footer2,Header4 },
          name:'Help',
          computed:{
              ...mapState([
                  'getClient',
                  'material'
              ])
          }
  
      }
   
  </script>
  
  <style scoped>
  .help{
      position: relative;
      overflow: hidden;
      top: 0;
      left: 0;
      padding: 50px 0 50px;
      background: #fff;
  }
  .help_title{
    text-align: center;
    padding-top: 48px;
    font-size: 1.75rem;
    font-weight: 400;
  }
  .system-title {
    border-left: 4px solid #ff3f3f;
    padding-left: 8px;
    font-size: 1.75rem;
    font-weight: 400;
}
  .card_body{
   display: flex;
   justify-content: center;

  }
  .card_box{
    width: 500px;
    height: 178px;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 0.25rem;
    transition: all .5s;
    margin-right: 10px;
  }
  .card_box:hover{
    border: 1px solid #ffc107;
    transition: all .5s;
  }
  .left_box{
    display: flex;
    flex-direction: column;
  }
  .card_text{
    font-size: 14px;
    color: #333;
  }
  .ewm{
    width: 120px;
    height: 120px;
  }
  @media (max-width: 1300px){
      .help{
          margin-top: 100px;
      }
  }
  @media (min-width: 1700px){
      .container {
          max-width: 1200px !important;
      } 
  }
  
  </style>